import cx from "classnames";
import * as React from "react";
import InfoIndicator from "@app/shared/InfoIndicator";

export interface QESRadioGroupProps {
  /**
   * A class for the div around all of the radio buttons
   */
  groupContainerClass?: string;
  /**
   * The label for the group as a whole
   * Does not cooperate with renderInline, unless you want the group label on the same line as the radios
   */
  groupLabel?: string;
  /**
   * ClassNames to add to the label
   */
  groupLabelClass?: string;
  informationalText?: string;
  /**
   * Extra class applied to the informational tooltip's portaled body (not the group itself).
   * Use when the group is rendered inside a modal — see InfoIndicator/TooltipWrapper's
   * tooltipBodyClassName for why the default z-index isn't enough there.
   */
  informationalTextTooltipBodyClassName?: string;
  /**
   * Width of the informational tooltip's body — see InfoIndicator/TooltipWrapper's tooltipWidth.
   * Without it the tooltip sizes to its text with no cap, which can run off-screen for longer copy.
   */
  informationalTextTooltipWidth?: string;
  /**
   * Whether a selection is required.
   */
  required?: boolean;
  /**
   * A simple flag that tells the group to render horizontally instead of vertically
   * Does not cooperate with groupLabel
   */
  renderInline?: boolean;
}

// /**
//  * This component renders a series of radio buttons, one for each provided label. They've been styled to match QES design guidelines.
//  */
export const QESRadioGroup: React.FC<React.PropsWithChildren<QESRadioGroupProps>> = (props: React.PropsWithChildren<QESRadioGroupProps>) => {
  return (
    <>
      <div
        className={cx({
          [props.groupContainerClass]: !!props.groupContainerClass,
          "qes-radio-group__container": true,
          "qes-radio-group__container--inline": props.renderInline,
        })}
      >
        {(props.groupLabel || props.required) &&
          <div
            className={cx({
              "qes-radio-group__group-label": true,
              "qes-radio-group__group-label--inline": props.renderInline,
              [props.groupLabelClass]: !!props.groupLabelClass,
            })}>
            {props.groupLabel}
            {props.required && <span className="qes-radio-group__group-required"> *</span>}
            {props.informationalText != null && props.informationalText != "" &&
              <span>&nbsp;<InfoIndicator className="informational-indicator" tooltipTitle={props.informationalText} tooltipPlacement="auto" tooltipBodyClassName={props.informationalTextTooltipBodyClassName} tooltipWidth={props.informationalTextTooltipWidth}/></span>
            }
          </div>}
        {props.children}
      </div>
    </>
  );
};
